import {lazy} from 'react';

const AuthCallback = lazy(() => import('./AuthCallback'));

export default AuthCallback;
